import {
  AttributeBlueBar,
  AttributesStyle,
  IconDiv,
  Modal,
  Overlay,
  Span,
  Title
} from "./styles";
import {
  ArrowRightGray,
  CustomButton,
  PhotoVideo,
  PlusIcon,
  Variables
} from "../../../../../assets";
import { Button } from "primereact/button";
import { setActionExceptionsRobot } from "../../../../../redux/slices/flowInteractions";
import { useAppDispatch } from "../../../../../redux/hooks";

interface OptionsExceptionsRobotActionsProps {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
}

export const OptionsExceptionsRobotActions = ({
  openModal,
  setOpenModal
}: OptionsExceptionsRobotActionsProps) => {
  const dispatch = useAppDispatch();

  const handleOptionClick = (action: string) => {
    dispatch(setActionExceptionsRobot(action));
    setOpenModal(false);
  };

  return (
    <Overlay style={{ display: openModal ? "block" : "none" }}>
      <Modal style={{ display: openModal ? "block" : "none" }} open={openModal}>
        <Button
          onClick={() => setOpenModal(false)}
          icon="pi pi-times"
          className="p-button-rounded p-button-danger p-button-text p-button-sm ml-auto"
          aria-label="Cancel"
        />

        <div className="flex mt-2 w-full justify-content-center align-items-center">
          <Title>Interações rápidas</Title>
          <Span>?</Span>
        </div>

        <AttributesStyle onClick={() => handleOptionClick("newDialog")}>
          <AttributeBlueBar />
          <div className="flex w-full align-items-center justify-content-between">
            <div className="flex align-items-center justify-content-start">
              <IconDiv>
                <img src={PlusIcon} alt="More-Bot-Interaction-Icon" />
              </IconDiv>
              <div>Caixa de diálogo do Bot</div>
            </div>
            <div className="mr-4">
              <img src={ArrowRightGray} alt="Arrow-Right-Gray-Icon" />
            </div>
          </div>
        </AttributesStyle>

        {/* <AttributesStyle onClick={() => handleOptionClick("newVariable")}>
          <AttributeBlueBar />
          <div className="flex w-full align-center justify-content-between">
            <div className="flex align-center justify-content-start">
              <IconDiv>
                <img src={Variables} alt="Add-Variables-Icon" />
              </IconDiv>
              <div>Adicionar variável</div>
            </div>
            <div className="mr-4">
              <img src={ArrowRightGray} alt="Arrow-Right-Gray-Icon" />
            </div>
          </div>
        </AttributesStyle> */}
      </Modal>
    </Overlay>
  );
};
